<template>
    <b-modal id="modal-phonevalidation" centered class="modal-phonevalidation">
      <div class="modal-phonevalidation-itens">
        <button
          class="modal-phonevalidation-itens-close"
          @click="$bvModal.hide('modal-phonevalidation')"
        >
        <img src="@/assets/img/close.png" alt="close" width="30">
        </button>
      </div>
      <div class="modal-phonevalidation-content">
        <h3>Vamos validar o seu Nº Telemóvel</h3>
        <p>Introduza o código SMS enviado para o seu Nº telemóvel.</p>
        <form @submit.prevent="sendForm()">
            <div class="row">
                <div class="col-md-12">
                    <input type="number" name="code" v-model="code" placeholder="Código de validação">
                </div>
            </div>
            <div class="content-input-button">
                <div class="btn btn-send">
                    <button type="submit">gravar</button>
                </div>
            </div>
        </form>
      </div>
    </b-modal>
  </template>
  
  <script>
import axios from 'axios';
import { mapState } from 'vuex';
  export default {
    data() {
      return {
        code: ''
      };
    },
    computed: {
        ...mapState(['hash']),  
    },
    methods: 
    {
      async sendForm(){
        await axios.post('api/v1/user/validation', {
            code: this.code,
            hash: this.hash || localStorage.getItem('hash')
        })
        .then((response) => {
          if(response.data.success){
              this.$swal.fire({
                  type: 'success',
                  title: 'Sucesso',
                  text: 'O seu número de telemóvel foi validado com sucesso!',
                  showConfirmButton: false,
                  timer: 3000
              });
              console.log(response.data.data.user.data);
              this.$store.dispatch('setUserLoggedIn', {
                token: response.data.data.user.data.id,  
                user: response.data.data.user.data
              });
              this.$bvModal.hide('modal-phonevalidation');
              this.$router.push({ name: 'Account' });

          } else {
                this.$swal.fire({
                    type: 'Alert',
                    title: '!',
                    text: response.data.error.error.context.payload.codigo.message,
                    showConfirmButton: false,
                    timer: 3000
                });
            }
        }).catch((error) => {
            this.$swal.fire({
                type: 'error',
                title: 'Erro',
                text: 'Não foi possível validar o seu número de telemóvel!',
                showConfirmButton: false,
                timer: 3000
            });
            console.log(error);
        });
      }

    },
  };
  </script>
  
  <style lang="scss">
  #modal-phonevalidation {
    .modal-header,
    .modal-footer {
      display: none;
    }
    .modal-dialog {
      max-width: 825px;
      margin: auto!important;;
      @media screen and (max-width: 991px) {
        max-width: 384px;
      }
    }
    .modal-content {
      border-radius: 0;
      border: 0;
      background-color: #F6F6F6!important;
    }
    .modal-body {
      height: 463px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      @media (max-width: 991px) {
        padding: 50px 20px;
        height: 463px;
      }
    }
  }
  .modal-phonevalidation {
    &-itens {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      justify-content: space-between;
      &-close {
        position: absolute;
        right: -45px;
        top: -40px;
        width: 83px;
        height: 83px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: black;
        border: 1px solid black;
        border-radius: 50%;
        transition: 500ms;
        @media (max-width: 991px) {
          top: 20px;
          right: 20px;
          width: 40px;
          height: 40px;
          svg {
            max-width: 15px;
          }
        }
        &:hover,
        &:focus {
          opacity: 0.6;
        }
      }
    }
    &-content{
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        gap: 20px;
        form{
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 34px;
            .row{
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-direction: row;
                input{
                    width: 100%;
                    height: 50px;
                    border: none;
                    background-color: var(--white);
                    border: 1px solid #B8B8B8;
                    text-align: center;
                    border-radius: 5px;
                    font-size: 18px;
                    font-family: "Font Regular";
                    color: #B8B8B8;
                    &::placeholder{
                        font-size: 18px;
                        font-family: "Font Regular";
                        color: var(--black);
                    }
                }
            }
        }
    }
  }
.content-input-button{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    button{
        width: 280px;
        height: 56px;
        border: none;
        background: rgb(254,206,9);
        background: linear-gradient(90deg, rgba(254,206,9,1) 0%, rgba(245,137,31,1) 100%);
        text-align: center;
        border-radius: 10px;
        padding: 0 20px;
        font-size: 18px;
        font-family: "Font Regular";
        color: black;
        transition: 500ms;
        text-transform: uppercase;
    }
    .btn-cancel button {
        width: 280px;
        height: 56px;
        border: 1px solid var(--main-color);
        background-color: var(--white);
        text-align: center;
        border-radius: 10px;
        padding: 0 20px;
        font-size: 18px;
        font-family: "Font Regular";
        color: var(--main-color);
        transition: 500ms;
        text-transform: uppercase;
        &:hover{
            background-color: var(--main-color);
            color: var(--white);
        }
    }
}
  </style>